<template>
  <div class="Essence">
    <div class="Essence_nav">
      <div class="Essence_one">
        <div class="Essence_title">
          <div v-for="(item,index) in title" :key="index" class="Essence_txt" v-if="index<2" @click="dian(item.zt,item.id)">
            <div class="Essence_name" :class="item.zt?'addtxt':''">
              <div style="width: auto;display: inline-block;padding-bottom: 8px;" :class="item.zt?'xian':''">{{item.txt}}</div>
            </div>
<!--            <div class="Essence_xian" v-if="index<1"></div> -->
          </div>
          <div class="Essence_right" @click="jump1(1)">
            <div class="zi">MORE></div>
          </div>
        </div>
        <div class="Essence_onenav">
          <div class="Essence_show" v-for="(item,index) in list" :key="index" v-if="index<4" @click="jump(item.contentId)">
           <div v-if="item.zt" style="overflow: hidden;width: 100%;">
             <div class="show_left">
               <img :src="item.titlePhoto" alt="">
             </div>
            <div class="show_right">
               <div class="show_one">
                 <div class="show_name">{{item.author}}</div>
                 <div class="show_txt"><a href="#">{{item.title}}</a></div>
                 <div class="show_txt2">{{item.abstruct}}</div>
               </div>
             </div>
           </div>
           <div v-if="!item.zt" @mouseenter="addtop(index)" style="overflow: hidden;width: 100%;">
             <div class="Essence_hide1" :style="{marginbottom:(item.zt?20+'px':'')}">
               <div class="Essence_left">
                 <div class="author_dian"></div>
               </div>
               <div class="Essence_right">
                 <div class="Essence_txt1"><span>{{item.author}}</span><a href="#">{{item.txt1}}</a></div>
                 <div class="Essence_txt2">{{item.abstruct}}</div>
               </div>
             </div>
           </div>
          </div>
        </div>
      </div>
      <div class="Essence_two">
<!--        <div class="Essence_title">
          <div v-for="(item,index) in title2" :key="index" class="Essence_txt" v-if="index<2" @click="dian2(item.zt,item.id)">
            <div class="Essence_name" :class="item.zt?'addtxt':''">
              {{item.txt}}
              <div class="Essence_xian2" v-if="item.zt"></div>
            </div>
            <div class="Essence_xian" v-if="index<1"></div>
          </div>
          <div class="Essence_right" @click="jump1()">
            <div class="zi">MORE></div>
          </div>
        </div> -->
        <div class="Essence_title">
          <div class="Essence_txt" style="width: auto;display: inline-block;padding-bottom: 8px;border-bottom: 3px solid var(--xt);">公益海报</div>
          <div class="Essence_right" @click="jump1(2)">
            <div class="zi">MORE></div>
          </div>
        </div>
        <div class="Essence_onenav">
          <div class="Essence_show" v-for="(item,index) in list2" :key="index" v-if="index<6" @click="jump2(item)">
           <div v-if="item.zt" style="overflow: hidden;width: 100%;">
             <div class="show_left">
               <img :src="item.titlePhoto" alt="" v-if="item.titlePhoto">
               <img v-if="!item.titlePhoto" src="http://uniappfile.boyuancb.com/UploadFile/SiteContent/TitlePhoto/988227300d6339151f66801e0815539.png" alt="">
             </div>
            <div class="show_right">
               <div class="show_one">
                 <div class="show_name">{{item.title}}</div>
                 <div class="show_txt2">{{item.abstruct}}</div>
               </div>
             </div>
           </div>
           <div v-if="!item.zt" @mouseenter="addtop2(index)" style="overflow: hidden;width: 100%;">
             <div class="Essence_hide1" :style="{marginbottom:(item.zt?20+'px':'')}">
               <div class="Essence_left">
                 <div class="author_dian"></div>
               </div>
               <div class="Essence_right">
                 <div class="Essence_txt3">{{item.title}}</div>
               </div>
             </div>
           </div>
          </div>
        </div>
      </div>
      <div class="Essence_three">
        <div class="Essence_title">
          <div class="Essence_txt" style="width: auto;display: inline-block;padding-bottom: 8px;border-bottom: 3px solid var(--xt);">指南与共识</div>
          <div class="Essence_right" @click="jump1(3)">
            <div class="zi">MORE></div>
          </div>
        </div>
        <div class="Essence_onenav">
          <div class="Essence_show" v-for="(item,index) in list3" :key="index" v-if="index<6" @click="jump3(item.filePath)">
           <div v-if="item.zt" style="overflow: hidden;width: 100%;">
             <div class="show_left">
               <img :src="item.titlePhoto" alt="">
             </div>
            <div class="show_right">
               <div class="show_one">
                 <div class="show_name">{{item.title}}</div>
                 <div class="show_txt2">{{item.abstruct}}</div>
               </div>
             </div>
           </div>
           <div v-if="!item.zt" @mouseenter="addtop3(index)" style="overflow: hidden;width: 100%;">
             <div class="Essence_hide1" :style="{marginbottom:(item.zt?20+'px':'')}">
               <div class="Essence_left">
                 <div class="author_dian"></div>
               </div>
               <div class="Essence_right">
                 <div class="Essence_txt3">{{item.title}}</div>
               </div>
             </div>
           </div>
          </div>
        </div>

      </div>
<!--      <div class="Essence_bottom">
        <div class="Essence_bottoml">
          <img src="/src/assets/tu7.png" alt="">
        </div>
        <div class="Essence_bottomr2">
          <img src="/src/assets/gg01.jpg" alt="">
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

 export default {
  data () {
    return {
      title:[
        {
          id: 1,
          txt: '专家学者'
        }
      ],
      list: [],//专家学者
      list2: [],//公益海报
      list3: []//指南与共识
    }
  },methods:{
    GetHomePageBlockInfo(channelId,jChannelID,dataSourceType){
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "journalId": that.$_JournalId,
        "pChannelId": 0,
        "channelId": channelId,
        "jChannelID": jChannelID,
        "dataSourceType": dataSourceType,
        "dataShowType": 1,
        "curr": 1,
        "limit": 10,
      }).then(res => {
        if(res.code==200){
          if(channelId==3075){
            that.list = res.data || '';
            for(var i=0;i<that.list.length;i++){
              if(i==0){
                that.list[i].zt = true;
                that.list.push('1');
                that.list.pop('1');
              }else{
                that.list[i].zt = false;
                that.list.push('1');
                that.list.pop('1');
              }
            }
          }else if(channelId==2803){
            that.list2 = res.data || '';
            for(var i=0;i<that.list2.length;i++){
              if(i==0){
                that.list2[i].zt = true;
                that.list2.push('1');
                that.list2.pop('1');
              }else{
                that.list2[i].zt = false;
                that.list2.push('1');
                that.list2.pop('1');
              }
            }
          }else if(jChannelID==1382){
            that.list3 = res.data || '';
            for(var i=0;i<that.list3.length;i++){
              if(i==0){
                that.list3[i].zt = true;
                that.list3.push('1');
                that.list3.pop('1');
              }else{
                that.list3[i].zt = false;
                that.list3.push('1');
                that.list3.pop('1');
              }
            }
          }
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //初始化页面
    index(){
      for(var i=0;i<this.title.length;i++){
        if(i==0){
          this.title[i].zt = true;
          this.title.push('1');
          this.title.pop('1');
        }else{
          this.title[i].zt = false;
          this.title.push('1');
          this.title.pop('1');
        }
      }
      //专家学者
      this.GetHomePageBlockInfo(3075,0,1);
      //公益广告
      this.GetHomePageBlockInfo(2803,0,1);
      //指南与共识
      this.GetHomePageBlockInfo(0,1382,3);
    },
    //标题点击事件
    dian(zt,id){
      if(!zt){
        for(var i=0;i<this.title.length;i++){
          if(id==this.title[i].id){
            this.title[i].zt = true;
            this.title.push('1');
            this.title.pop('1');
          }else{
            this.title[i].zt = false;
            this.title.push('1');
            this.title.pop('1');
          }
        }
      }
    },
    // //标题点击事件
    // dian2(zt,id){
    //   if(!zt){
    //     for(var i=0;i<this.title2.length;i++){
    //       if(id==this.title2[i].id){
    //         this.title2[i].zt = true;
    //         this.title2.push('1');
    //         this.title2.pop('1');
    //       }else{
    //         this.title2[i].zt = false;
    //         this.title2.push('1');
    //         this.title2.pop('1');
    //       }
    //     }
    //   }
    // },
    //专家箴言鼠标悬停
    addtop(id){
      for(var i=0;i<this.list.length;i++){
        if(id==i){
          this.list[i].zt = true;
          this.list.push('1');
          this.list.pop('1');
        }else{
          this.list[i].zt = false;
          this.list.push('1');
          this.list.pop('1');
        }
      }
    },
    //精华转载鼠标悬停
    addtop2(id){
      for(var i=0;i<this.list2.length;i++){
        if(id==i){
          this.list2[i].zt = true;
          this.list2.push('1');
          this.list2.pop('1');
        }else{
          this.list2[i].zt = false;
          this.list2.push('1');
          this.list2.pop('1');
        }
      }
    },
    //指南与共识鼠标悬
    addtop3(id){
      for(var i=0;i<this.list3.length;i++){
        if(id==i){
          this.list3[i].zt = true;
          this.list3.push('1');
          this.list3.pop('1');
        }else{
          this.list3[i].zt = false;
          this.list3.push('1');
          this.list3.pop('1');
        }
      }
    },
    jump1(id){
      if(id==1){
        this.$router.push({path:'/expert'});
      }else if(id==2){
        this.$router.push({path:'/poster'});
      }else if(id==3){
        this.$router.push({path:'/guide'});
      }

    },
    jump(contentId){
      this.$router.push({path:'/expert_details',query:{num:1,contentId:contentId}});
    },
    jump2(item){
      var data = JSON.stringify(item);
      this.$router.push({path:'/poster_details',query:{item:data}});
    },
    jump3(linkurl){
      window.open(linkurl);
    }
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
.Essence{
    width: 100%;
    height: 100%;
    min-width: 1366px;
    background-image: url(/src/assets/tu6.png);
    background-size: cover;
    background-size: 100% 100%;
    padding-bottom: 56px;
    padding-top: 54px;
    .Essence_nav{
      width: 85%;
      margin: 0 auto;
      overflow: hidden;
      .Essence_one{
        width: 35%;
        height: 496px;
        margin-right: 1%;
        float: left;
        background-color: #FFFFFF;
        padding-top: 30px;
        position: relative;
        .shuxian{
          width: 10%;
          position: absolute;
          left: 10px;
          top: 30px;
          .Journalism_xian1{
            width: 4px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 4px;
            margin-top: 7px;
          }
          .Journalism_xian2{
            width: 2px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 12px;
            margin-top: 7px;
          }
        }
        .Essence_title{
        	width: 90%;
          margin: 0 auto;
          height: 35px;
          border-bottom: 2px solid #EEEEEE;
          padding-bottom: 11px;
          margin-bottom: 19px;
          .Essence_name{
            width: 100%;
            font-size: 18px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            position: relative;
            .Essence_xian2{
              width: 100%;
              height: 3px;
              background: var(--biao);
              position: absolute;
              bottom: -10px;
              left: 0;
            }
          }
        	.Essence_xian{
        		width: 4px;
        		height: 21px;
        		background: var(--xt);
        		float: right;
        	}
        	.Essence_txt{
        		width: 30%;
            cursor: pointer;
        		font-size: 18px;
        		font-family: Source Han Sans SC;
        		font-weight: 400;
        		color: #000000;
        		line-height: 38px;
        		position: relative;
            text-align: center;
            float: left;
        		.Essence_xian{
              width: 2px;
              height: 16px;
              background: #EEEEEE;
        			position: absolute;
        			right: 0;
              top: 14px;
        		}
        	}
          .Essence_txt:first-child{
            width: 23%;
            text-align: left;
          }
        	.Essence_right{
        		float: right;
        		width: 90px;
        		height: 12px;
        		font-size: 14px;
        		font-family: Source Han Sans SC;
        		font-weight: bold;
        		color: #878787;
        		line-height: 23px;
            cursor: pointer;
            text-align: right;
            .zi{
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
        	}
        }
        .Essence_onenav{
          width: 90%;
          margin: 0 auto;
          overflow: hidden;
          padding-bottom: 15px;
          .Essence_show{
            width: 100%;
            overflow: hidden;
            margin-bottom: 25px;
            cursor: pointer;
            .show_left{
              width: 120px;
              height: 169px;
              float: left;
              padding-right: 4%;
              img{
                width: 100%;
                height: 169px;
              }
              img:hover{
                transform: scale(1.05);
              }
            }
            .show_right{
              width: 62%;
              float: left;
              .show_one{
                width: 100%;
                overflow: hidden;
                .show_name{
                  width: 35%;
                  font-size: 18px;
                  font-family: Source Han Sans SC;
                  font-weight: bold;
                  color: var(--biao);
                  line-height: 23px;
                  float: left;
                }
                .show_txt{
                  width: 65%;
                  float: left;
                  height: 23px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow:hidden;
                  a{
                    font-size: 18px;
                    font-family: Adobe Heiti Std;
                    font-weight: bold;
                    text-decoration: none;
                    color: var(--zhuan);
                  }
                  a:hover{
                    text-decoration: underline;
                  }
                }
                .show_txt2{
                  width: 100%;
                  padding-top: 10px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 5;
                  overflow: hidden;
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #414141;
                  line-height: 28px;
                }
              }
            }
          }
          .Essence_hide1{
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            .Essence_left{
              float: left;
              .author_dian{
                width: 10px;
                height: 10px;
                background: #DBDBDB;
                border-radius: 50%;
                margin-right: 21px;
                margin-top: 7px;
              }
            }
            .Essence_right{
              width: 80%;
              float: left;
              overflow: hidden;
              .Essence_txt1{
                width: 100%;
                overflow: hidden;
                span{
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #000000;
                  width: 20%;
                  float: left;
                }
                a{
                  width: 80%;
                  float: left;
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  text-decoration: underline;
                  color: #203B91;
                }
              }
              .Essence_txt2{
                width: 90%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #848484;
                margin-top: 5px;
                white-space: nowrap;//强制字体不换行
                text-overflow: ellipsis;//超出字体隐藏
                overflow:hidden;
              }
              .Essence_txt3{
                width: 90%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                margin-top: 5px;
                white-space: nowrap;//强制字体不换行
                text-overflow: ellipsis;//超出字体隐藏
                overflow:hidden;
              }
            }
          }
        }
      }
      .Essence_two{
        width: 32%;
        height: 496px;
        margin-right: 1%;
        float: left;
        background-color: #FFFFFF;
        padding-top: 30px;
        position: relative;
        .shuxian{
          width: 10%;
          position: absolute;
          left: 10px;
          top: 30px;
          .Journalism_xian1{
            width: 4px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 4px;
            margin-top: 7px;
          }
          .Journalism_xian2{
            width: 2px;
            height: 21px;
            background: var(--xt);
            float: left;
            margin-right: 12px;
            margin-top: 7px;
          }
        }
        .Essence_title{
        	width: 90%;
          margin: 0 auto;
        	height: 35px;
          border-bottom: 2px solid #EEEEEE;
          position: relative;
          padding-bottom: 11px;
          margin-bottom: 19px;
          .Essence_name{
            width: 100%;
            font-size: 18px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
            position: relative;
            .Essence_xian2{
              width: 100%;
              height: 3px;
              background: var(--biao);
              position: absolute;
              bottom: -10px;
              left: 0;
            }
          }
        	.Essence_xian{
        		width: 4px;
        		height: 21px;
        		background: var(--xt);
        		float: left;
            margin-right: 4px;
        	}
        	.Essence_txt{
        		width: 30%;
            cursor: pointer;
        		font-size: 18px;
        		font-family: Source Han Sans SC;
        		font-weight: 400;
        		color: #000000;
        		line-height: 38px;
        		position: relative;
            text-align: left;
            float: left;
        		.Essence_xian{
              width: 2px;
              height: 16px;
              background: #EEEEEE;
        			position: absolute;
        			right: 0;
              top: 14px;
        		}
        	}
        	.Essence_right{
        		float: right;
        		width: 90px;
        		height: 12px;
        		font-size: 14px;
        		font-family: Source Han Sans SC;
        		font-weight: bold;
        		color: #878787;
        		line-height: 23px;
            cursor: pointer;
            text-align: right;
            .zi{
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
        	}
          .Essence_xian2{
            width: 102px;
            height: 3px;
            background: var(--biao);
            position: absolute;
            bottom: 0;
            left: 0;
          }
          .Essence_xian{
          	width: 4px;
          	height: 21px;
          	background: var(--xt);
          	float: left;
            margin-right: 4px;
            margin-top: 7px;
          }
          .Essence_txt{
          	width: 60%;
            cursor: pointer;
          	font-size: 20px;
          	font-family: Source Han Sans SC;
          	font-weight: bold;
          	color: #000000;
          	line-height: 38px;
          	position: relative;
            float: left;
          	.Essence_xian{
              width: 2px;
              height: 16px;
              background: #EEEEEE;
          		position: absolute;
          		right: 0;
              top: 14px;
          	}
          }
          .Essence_right{
          	float: right;
          	width: 90px;
          	height: 12px;
          	font-size: 14px;
          	font-family: Source Han Sans SC;
          	font-weight: bold;
          	color: #878787;
          	line-height: 23px;
            cursor: pointer;
            text-align: right;
            .zi{
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
          }
        }
        .Essence_onenav{
          width: 90%;
          margin: 0 auto;
          overflow: hidden;
          padding-bottom: 15px;
          .Essence_show{
            width: 100%;
            overflow: hidden;
            margin-bottom: 18.5px;
            cursor: pointer;
            .show_left{
              width: 120px;
              height: 170px;
              float: left;
              padding-right: 4%;
              img{
                width: 100%;
                height: 169px;
              }
              img:hover{
                transform: scale(1.05);
              }
            }
            .show_right{
              width: 59%;
              float: left;
              .show_one{
                width: 100%;
                overflow: hidden;
                .show_name{
                  width: 100%;
                  font-size: 18px;
                  font-family: Source Han Sans SC;
                  font-weight: bold;
                  color: var(--biao);
                  line-height: 23px;
                  float: left;
                  white-space: nowrap;//强制字体不换行
                  text-overflow: ellipsis;//超出字体隐藏
                  overflow:hidden;
                }
                .show_txt{
                  width: 65%;
                  float: left;
                  height: 23px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow:hidden;
                  a{
                    font-size: 18px;
                    font-family: Adobe Heiti Std;
                    font-weight: bold;
                    text-decoration: underline;
                    color: var(--zhuan);
                  }
                }
                .show_txt2{
                  width: 100%;
                  padding-top: 10px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 5;
                  overflow: hidden;
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #414141;
                  line-height: 28px;
                }
              }
            }
          }
          .Essence_hide1{
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            .Essence_left{
              float: left;
              .author_dian{
                width: 10px;
                height: 10px;
                background: #DBDBDB;
                border-radius: 50%;
                margin-right: 21px;
                margin-top: 10px;
              }
            }
            .Essence_right{
              width: 80%;
              float: left;
              overflow: hidden;
              .Essence_txt1{
                width: 100%;
                overflow: hidden;
                span{
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #000000;
                  width: 20%;
                  float: left;
                }
                a{
                  width: 80%;
                  float: left;
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  text-decoration: underline;
                  color: #203B91;
                }
              }
              .Essence_txt2{
                width: 90%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #848484;
                margin-top: 5px;
                white-space: nowrap;//强制字体不换行
                text-overflow: ellipsis;//超出字体隐藏
                overflow:hidden;
              }
              .Essence_txt3{
                width: 90%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                margin-top: 5px;
                white-space: nowrap;//强制字体不换行
                text-overflow: ellipsis;//超出字体隐藏
                overflow:hidden;
              }
            }
          }
        }
      }
      .Essence_three{
        width: 31%;
        height: 496px;
        float: left;
        background-color: #FFFFFF;
        padding-top: 30px;
        .Essence_title{
        	width: 90%;
          margin: 0 auto;
        	overflow: hidden;
          border-bottom: 2px solid #EEEEEE;
          position: relative;
          margin-bottom: 19px;
          .Essence_xian2{
            width: 102px;
            height: 3px;
            background: var(--biao);
            position: absolute;
            bottom: 0;
            left: 0;
          }
        	.Essence_xian{
        		width: 4px;
        		height: 21px;
        		background: var(--xt);
        		float: left;
            margin-right: 4px;
            margin-top: 7px;
        	}
        	.Essence_txt{
        		width: 60%;
            cursor: pointer;
        		font-size: 20px;
        		font-family: Source Han Sans SC;
        		font-weight: bold;
        		color: #000000;
        		line-height: 38px;
        		position: relative;
            float: left;
        		.Essence_xian{
              width: 2px;
              height: 16px;
              background: #EEEEEE;
        			position: absolute;
        			right: 0;
              top: 14px;
        		}
        	}
        	.Essence_right{
        		float: right;
        		width: 90px;
        		height: 12px;
        		font-size: 14px;
        		font-family: Source Han Sans SC;
        		font-weight: bold;
        		color: #878787;
        		line-height: 23px;
            cursor: pointer;
            text-align: right;
            .zi{
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              margin-right: 9px;
              margin-top: 8px;
            }
        	}
        }
        .Essence_onenav{
          width: 90%;
          margin: 0 auto;
          overflow: hidden;
          padding-bottom: 12px;
          .Essence_show{
            width: 100%;
            overflow: hidden;
            margin-bottom: 18.5px;
            cursor: pointer;
            .show_left{
              width: 120px;
              height: 170px;
              float: left;
              padding-right: 4%;
              img{
                width: 100%;
                height: 169px;
              }
              img:hover{
                transform: scale(1.05);
              }
            }
            .show_right{
              max-width: 58%;
              float: left;
              .show_one{
                width: 100%;
                overflow: hidden;
                .show_name{
                  width: 70%;
                  font-size: 18px;
                  font-family: Source Han Sans SC;
                  font-weight: bold;
                  color: var(--biao);
                  line-height: 23px;
                  float: left;
                  white-space: nowrap;//强制字体不换行
                  text-overflow: ellipsis;//超出字体隐藏
                  overflow:hidden;
                }
                .show_txt{
                  width: 65%;
                  float: left;
                  height: 23px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow:hidden;
                  a{
                    font-size: 18px;
                    font-family: Adobe Heiti Std;
                    font-weight: bold;
                    text-decoration: underline;
                    color: var(--zhuan);
                  }
                }
                .show_txt2{
                  width: 100%;
                  padding-top: 10px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 5;
                  overflow: hidden;
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #414141;
                  line-height: 28px;
                }
              }
            }
          }
          .Essence_hide1{
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            .Essence_left{
              float: left;
              .author_dian{
                width: 10px;
                height: 10px;
                background: #DBDBDB;
                border-radius: 50%;
                margin-right: 21px;
                margin-top: 10px;
              }
            }
            .Essence_right{
              width: 80%;
              float: left;
              overflow: hidden;
              .Essence_txt1{
                width: 100%;
                overflow: hidden;
                span{
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  color: #000000;
                  width: 20%;
                  float: left;
                }
                a{
                  width: 80%;
                  float: left;
                  font-size: 16px;
                  font-family: Adobe Heiti Std;
                  font-weight: normal;
                  text-decoration: underline;
                  color: #203B91;
                }
              }
              .Essence_txt2{
                width: 90%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #848484;
                margin-top: 5px;
                white-space: nowrap;//强制字体不换行
                text-overflow: ellipsis;//超出字体隐藏
                overflow:hidden;
              }
              .Essence_txt3{
                width: 100%;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
                margin-top: 5px;
                white-space: nowrap;//强制字体不换行
                text-overflow: ellipsis;//超出字体隐藏
                overflow:hidden;
              }
            }
          }
        }
      }
      .Essence_bottom{
        width: 100%;
        padding-top: 20px;
        overflow: hidden;
        .Essence_bottoml{
          width: 71%;
          margin-right: 1%;
          float: left;
          img{
            width: 100%;
            height: 120px;
            background-size: cover;
            cursor: pointer;
          }
          img:hover{
            transform: scale(1.05);
          }
        }
        .Essence_bottomr2{
          width: 28%;
          height: 120px;
          float: left;
          img{
            width: 100%;
            height: 120px;
            background-size: cover;
            cursor: pointer;
          }
          img:hover{
            transform: scale(1.05);
          }
        }
      }
    }
}
.addtxt{
  font-weight: bold!important;
  font-size: 20px!important;
}
.xian{
  border-bottom: 3px solid var(--xt)!important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/Essence.vue